import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";
import { applySemesters } from '@/util';

function state() {
	return Object.assign(
		{
			options: applySemesters("umpi")
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
